var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-row',[_c('v-col',[_c('image-upload',{ref:"image",attrs:{"label":"Изображениее","existing-image-url":"http://localhost:8080/img/course-sample.2f79df02.png"}}),_c('v-btn',{on:{"click":_vm.testUpload}},[_vm._v("test upload")])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }